import { AlertCircle, AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
import { cn } from '../../utils/helpers';
import { t } from '../../i18n';
import { useToastStore } from '../../store';

const ICONS = { success: CheckCircle, error: AlertCircle, warning: AlertTriangle, info: Info };
const COLORS = {
  success: 'border-green-200 bg-green-50 text-green-800',
  error: 'border-red-200 bg-red-50 text-red-800',
  warning: 'border-amber-200 bg-amber-50 text-amber-800',
  info: 'border-sky-200 bg-sky-50 text-sky-800',
};

export function ToastContainer() {
  const { toasts, dismiss } = useToastStore();
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-full max-w-sm flex-col gap-2 px-4 sm:px-0" aria-live="polite">
      {toasts.map((item) => {
        const Icon = ICONS[item.type];
        return (
          <div
            key={item.id}
            role={item.type === 'error' ? 'alert' : 'status'}
            className={cn('pointer-events-auto flex items-start gap-3 rounded-lg border p-3 shadow-lg animate-slide-in', COLORS[item.type])}
          >
            <Icon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
            <p className="flex-1 text-sm">{item.message}</p>
            {item.action && (
              <button
                onClick={() => {
                  dismiss(item.id);
                  item.action!.onClick();
                }}
                className="shrink-0 text-sm font-semibold underline underline-offset-2 hover:no-underline"
              >
                {item.action.label}
              </button>
            )}
            <button onClick={() => dismiss(item.id)} className="shrink-0 opacity-60 hover:opacity-100" aria-label={t('Zavrieť')}>
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
